
import { tryParse as tryParse_1 } from "../fable_modules/fable-library-js.5.3.0/Guid.js";
import { FSharpRef } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.3.0/Result.js";
import { concat } from "../fable_modules/fable-library-js.5.3.0/String.js";

export function tryParse(s) {
    let matchValue;
    let outArg = "00000000-0000-0000-0000-000000000000";
    matchValue = [tryParse_1(s, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return new FSharpResult$2(0, [matchValue[1]]);
    }
    else {
        return new FSharpResult$2(1, [concat("Invalid GUID format: ", s)]);
    }
}

//# sourceMappingURL=Parsing.js.map
